/* ============================================================
   Bernamo — header scroll state (companion to
   custom-header-contrast.css)

   Deliberately dumb: it does NOT measure anything. Which pages get
   a white header at the top is decided in CSS (body.header-light,
   set in theme.liquid), so it is uniform on every device and load.

   All this does is: once the page is scrolled past a small
   threshold, mark the header as scrolled and paint a white bar with
   a small drop shadow behind it. The CSS then puts the elements
   back to black.

   The bar is painted on `.header` (not `.header-wrapper`): the theme
   forces both to position:absolute, which collapses the wrapper to
   0 height, so a background on it would paint nothing. It is set
   inline with !important because the theme's forced-transparent
   header background carries an ID and would otherwise win.
   ============================================================ */
(function () {
  var wrapper = document.querySelector('.header-wrapper');
  if (!wrapper) return;

  var bar = wrapper.querySelector('.header') || wrapper;
  var SCROLL_TRIGGER = 40; // px scrolled before the white bar shows

  function scrollY() {
    return window.pageYOffset || document.documentElement.scrollTop || 0;
  }

  function apply() {
    var scrolled = scrollY() > SCROLL_TRIGGER;
    wrapper.classList.toggle('header--scrolled', scrolled);

    if (scrolled) {
      bar.style.setProperty('background-color', '#ffffff', 'important');
      bar.style.setProperty('box-shadow', '0 2px 10px rgba(0, 0, 0, 0.08)', 'important');
    } else {
      bar.style.removeProperty('background-color');
      bar.style.removeProperty('box-shadow');
    }
  }

  var ticking = false;
  window.addEventListener('scroll', function () {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () { ticking = false; apply(); });
  }, { passive: true });

  window.addEventListener('resize', apply);
  apply();

  // Turn the transitions on only after the initial state is painted.
  requestAnimationFrame(function () {
    document.documentElement.classList.add('header-fx-ready');
  });
})();
